var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-app',[_c('layout-app-bar'),_c('layout-main',[_vm._t("default")],2),_c('footer-import')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }